import { Problem, ProblemDetectionContext, ProblemSeverity, ProblemType } from '../types';

export const detectFlowBlockDurations = (context: ProblemDetectionContext, generateId: () => string): Problem[] => {
  const problems: Problem[] = [];

  if (!context.flowLogs || context.flowLogs.length < 2) {
    return problems;
  }

  const sortedEvents = [...context.flowLogs].sort(
    (a, b) => new Date(a.Timestamp).getTime() - new Date(b.Timestamp).getTime()
  );

  const ignoredBlocks = ['ShowView', 'PlayPrompt', 'GetUserInput'];

  for (let i = 1; i < sortedEvents.length; i++) {
    const currentEvent = sortedEvents[i];
    const previousEvent = sortedEvents[i - 1];

    if (
      ignoredBlocks.includes(previousEvent.ContactFlowModuleType) ||
      ignoredBlocks.includes(currentEvent.ContactFlowModuleType)
    ) {
      continue;
    }

    const currentTime = new Date(currentEvent.Timestamp).getTime();
    const previousTime = new Date(previousEvent.Timestamp).getTime();
    const duration = currentTime - previousTime;

    const thresholdMs = 500;
    const criticalThresholdMs = 2000; // 2 seconds

    if (duration > thresholdMs) {
      const severity = duration > criticalThresholdMs ? ProblemSeverity.HIGH : ProblemSeverity.MEDIUM;
      const originalIndex = context.flowLogs!.indexOf(currentEvent);

      problems.push({
        id: generateId(),
        type: ProblemType.FLOW_EXECUTION_DELAY,
        severity,
        title: `Slow Block Execution: ${previousEvent.ContactFlowModuleType}`,
        description: `Block ${previousEvent.ContactFlowModuleType} took ${duration}ms to execute (threshold: ${thresholdMs}ms)`,
        timestamp: currentEvent.Timestamp,
        source: 'FLOW_LOG',
        relatedData: {
          durationMs: duration,
          thresholdMs,
          blockType: previousEvent.ContactFlowModuleType,
          identifier: previousEvent.Identifier,
          contactFlowName: previousEvent.ContactFlowName,
          parameters: previousEvent.Parameters,
          results: previousEvent.Results,
          startTime: previousEvent.Timestamp,
          endTime: currentEvent.Timestamp
        },
        suggestions: [
          'Review block configuration for optimization opportunities',
          'Check if external service calls are causing delays',
          'Consider implementing timeout handling for slow operations',
          duration > criticalThresholdMs
            ? 'This delay may significantly impact user experience'
            : 'Monitor this block for performance trends'
        ],
        index: originalIndex >= 0 ? originalIndex : undefined
      });
    }
  }

  return problems;
};
